import { render, staticRenderFns } from "./AccessDeniedToFacturaEPopup.vue?vue&type=template&id=5043dbb7&scoped=true&"
import script from "./AccessDeniedToFacturaEPopup.vue?vue&type=script&lang=js&"
export * from "./AccessDeniedToFacturaEPopup.vue?vue&type=script&lang=js&"
import style0 from "./AccessDeniedToFacturaEPopup.vue?vue&type=style&index=0&id=5043dbb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5043dbb7",
  null
  
)

export default component.exports